import { httpClient } from '@/services/http/httpClient'

type Params = {
  terms: string
}

export async function changeTermsOfUse({ terms }: Params) {
  await httpClient.post('/tennants/configs/company-terms', {
    terms,
  })
}
